module.exports = __webpack_public_path__ + "static/ibotta2-68d13725aa4426fb6bfbcc0fd4d1d867.png";